/**
 * Kleine Hilfen rund um den HTML-Text eines Wissensartikels.
 *
 * **Geschrieben wird im ``RichTextEditor``.** Hier stand frueher eine eigene
 * Formatierleiste, die HTML-Tags in ein Textfeld schrieb -- eine von zwei
 * verschiedenen Leisten in der Anwendung. Seit es **einen** Editor fuer alle
 * Masken gibt (F1-10), bleibt an dieser Stelle nur noch, was mit dem
 * gespeicherten Text zu tun hat.
 *
 * **Keine Vorschau des ungespeicherten HTML.** Der Editor zeigt den Text
 * ohnehin formatiert, waehrend er entsteht; fuer das Gespeicherte ist
 * ``RichText`` zustaendig, und das setzt kein HTML ein, sondern baut
 * Elemente aus dem, was auf der Liste steht.
 */

/** Der sichtbare Text eines Abschnitts -- fuer Auszug und Suche. */
export function plainText(html: string): string {
  return html
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Eine Sprungmarke aus einer Abschnittsaufschrift.
 *
 * Sie muss innerhalb der Seite eindeutig und als Fragment gueltig sein; der
 * Index sorgt fuer beides, auch wenn zwei Abschnitte gleich heissen.
 */
export function sectionAnchor(index: number): string {
  return `kb-abschnitt-${String(index + 1)}`;
}
